// Course data for "Python - Advanced"
// This data is used to create the advanced Python course with interactive components

export const pythonAdvancedCourseData = {
  title: '🐍 Python - Advanced',
  description: 'Master advanced Python concepts including decorators, generators, async programming, design patterns, and professional development practices! 🚀✨',
  courseType: 'programming',
  category: 'Python',
  level: 'advanced',
  topics: [
    {
      name: '📚 1: Advanced Functions & Decorators',
      description: `🎯 Function closures and scope
✨ Decorators: @property, @staticmethod, @classmethod
💻 Creating custom decorators
🎨 Decorator patterns and use cases
🎉 Project: Build a timing and logging decorator system`,
      hours: 2
    },
    {
      name: '📚 2: Generators & Iterators',
      description: `🔄 Generator functions and yield
📊 Iterator protocol and __iter__, __next__
⚡ Memory-efficient data processing
🧮 Generator expressions vs list comprehensions
🎲 Project: Build a data streaming pipeline`,
      hours: 2
    },
    {
      name: '✅ 3: Context Managers & Resource Management',
      description: `🔀 with statement and context managers
⚖️ Creating custom context managers
🧠 __enter__ and __exit__ methods
📦 Using contextlib for simpler managers
🎯 Project: Database connection manager`,
      hours: 2
    },
    {
      name: '✅ 4: Metaclasses & Class Design',
      description: `🔄 Understanding metaclasses
📊 __new__ vs __init__
⚙️ Custom class creation
🎨 Design patterns with metaclasses
💡 Project: Build a plugin system using metaclasses`,
      hours: 2
    },
    {
      name: '✅ 5: Async Programming & Concurrency',
      description: `⚙️ async/await syntax
♻️ asyncio library and event loops
📥 Coroutines and tasks
🔄 Concurrent execution patterns
📖 Project: Build an async web scraper`,
      hours: 2
    },
    {
      name: '🟣 6: Advanced Data Structures',
      description: `🤖 Collections module: defaultdict, Counter, deque
🌐 Named tuples and dataclasses
📚 Custom data structures
🎓 Advanced list/dict operations
🎯 Project: Build a custom priority queue`,
      hours: 2
    },
    {
      name: '📚 7: Design Patterns in Python',
      description: `📋 Singleton, Factory, Observer patterns
🤖 Strategy and Command patterns
📊 Pythonic pattern implementations
😊 Project: Implement a complete design pattern library`,
      hours: 2
    },
    {
      name: '🔧 8: Testing & Debugging Advanced Techniques',
      description: `🤖 pytest framework and fixtures
🔌 Mocking and patching
🐍 Advanced debugging with pdb
🖥️ Performance profiling
🤖 Project: Comprehensive test suite for a library`,
      hours: 2
    },
    {
      name: '🔧 9: Package Development & Distribution',
      description: `⚙️ Creating Python packages
📡 setup.py and pyproject.toml
📝 Documentation with Sphinx
📦 Publishing to PyPI
🤖 Project: Build and publish your own package`,
      hours: 2
    },
    {
      name: '🎉 10: Advanced Project - Full Stack Application',
      description: `🎯 Build a complete application using:
🎮 Advanced Python features
🖼️ Async programming
🖼️ Design patterns
🤖 Testing and deployment
🎉 Final Project: Production-ready application`,
      hours: 2
    }
  ]
};

// Interactive components to assign at course level
export const pythonAdvancedComponents = [
  'Code Editor',
  'Code Challenge',
  'Code Review',
  'API Explorer',
  'Database Designer',
  'Quiz Master',
  'Virtual Lab',
  'Whiteboard',
  'Portfolio Builder',
  'Progress Tracker'
];

